import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import './LoginForm.css';

const LoginForm = ({ onLoginSuccess }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const isMountedRef = useRef(true);
  
  useEffect(() => {
    console.log('[LoginForm] Component mounted');
    
    return () => {
      console.log('[LoginForm] Component unmounting!');
      isMountedRef.current = false;
    };
  }, []);
  
  useEffect(() => {
    if (error) {
      console.log('[LoginForm] Error state updated:', error);
    }
  }, [error]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    console.log('[LoginForm] Submit - Current URL:', window.location.href);
    console.log('[LoginForm] Form validation prevented, default action prevented');
    
    // Prevent double submission
    if (loading) {
      console.log('[LoginForm] Already loading, preventing double submit');
      return;
    }
    
    setLoading(true);
    setError('');

    const result = await authService.login(formData.email, formData.password);
    
    if (result.success) {
      console.log('[LoginForm] Login success, calling onLoginSuccess');
      onLoginSuccess(result.user);
      // Navigate to dashboard after successful login
      console.log('[LoginForm] Navigating to dashboard...');
      navigate('/');
    } else {
      console.log('[LoginForm] Login failed, showing error:', result.error);
      console.log('[LoginForm] Component mounted:', true);
      console.log('[LoginForm] Current URL after error:', window.location.href);
      
      // Translate common error messages to German
      let errorMessage = result.error;
      if (errorMessage === 'Invalid credentials') {
        errorMessage = 'Ungültige Anmeldedaten. Bitte überprüfen Sie E-Mail und Passwort.';
      } else if (errorMessage === 'Account is inactive') {
        errorMessage = 'Dein Konto ist deaktiviert. Bitte wende dich an einen Administrator.';
      } else if (errorMessage.includes('locked')) {
        errorMessage = 'Dein Konto ist aufgrund zu vieler fehlgeschlagener Anmeldeversuche vorübergehend gesperrt.';
      }
      setError(errorMessage);
      
      // Only update loading state if component is still mounted
      if (isMountedRef.current) {
        setLoading(false);
      }
      
      // Add timeout to check if error persists
      setTimeout(() => {
        if (isMountedRef.current) {
          console.log('[LoginForm] After 1s - Error still visible?', !!document.querySelector('.error-message'));
          console.log('[LoginForm] After 1s - Current URL:', window.location.href);
          console.log('[LoginForm] After 1s - Component still mounted?', isMountedRef.current);
        }
      }, 1000);
      
      setTimeout(() => {
        if (isMountedRef.current) {
          console.log('[LoginForm] After 3s - Error still visible?', !!document.querySelector('.error-message'));
          console.log('[LoginForm] After 3s - Current URL:', window.location.href);
          console.log('[LoginForm] After 3s - Component still mounted?', isMountedRef.current);
        }
      }, 3000);
      
      return; // Exit early to prevent loading state update below
    }
    
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Mosterei-Management</h2>
        <p>Anmeldung erforderlich</p>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label htmlFor="email">E-Mail:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Passwort:</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>
          
          <button type="submit" disabled={loading} className="login-button">
            {loading ? 'Anmeldung läuft...' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;